import React from 'react'
import construction from './construction.png'

function Profile() {
    return (
        <div className="container-fluid login-background">
                        <h1 className='hide'> space</h1>
                        <div className='center'>
                <div className='login-info'>
                <div className='row'>
                <h1>This is a profile page for: {localStorage.user}</h1>
            </div>
            <div className='row'>
                <div className='col'>
                    <img src={construction}  style={{width: "25vh"}}></img>
                </div>
              
            </div>
            <div className='row'>
                     {/* <a href="/Profile-Edit"><button>Edit Profile</button></a> */}
                     <h4>Unfortunately this part of the website is still under construction.</h4>
                     <h4>Once updated, users will be able to:</h4>
                     <p>Show off their favorite games</p>
                     <p>Show off scores they've given to games</p>
                     <p> Much more!</p>
                </div>

                </div>
            </div>
          
        </div>
    )
}

export default Profile